import { RouteObject } from 'react-router-dom'
import { LocationSearchPage } from './location-search'

export const LocationSearchRoute: RouteObject = {
    path: '/location-search',
    element: <LocationSearchPage />,
}
